/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import { Stack, mergeStyles } from '@fluentui/react';
import { ScheduleFrequencyIconEditor } from '@bingads-webui-campaign/reports-v4-schedule-frequency-icon-editor';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { CronFormatter } from '@bingads-webui/cron-formatter';
import { LegacyI18n } from '@bingads-webui-campaign/report-shared';
import { getFrequency } from './cronConverter';
import { isReportShared as getIsReportShared } from '../../helpers/is-report-shared';

const triviaClassName = mergeStyles({
  paddingLeft: '8px',
  paddingRight: '8px',
});

const schedulerTextClassName = mergeStyles({
  marginRight: 4,
});

const labelClassName = mergeStyles({
  color: '#605E5C',
  fontSize: '12px',
});


export function Trivia(props) {
  const {
    onSchedulerSaveClick,
    schedulerOptions,
    typeOfReport,
  } = props;
  const i18n = useContext(I18nContext);
  const legacyI18n = useContext(LegacyI18n);
  const cronFormatter = new CronFormatter({ i18n: legacyI18n });

  const displayFrequency = (() => {
    if (schedulerOptions.Cron && schedulerOptions.Cron !== '') {
      return getFrequency(schedulerOptions.Cron, cronFormatter);
    }
    return i18n.getString(_TL_('None'));
  })();

  const isReportShared = getIsReportShared(typeOfReport);

  return (
    <Stack className={triviaClassName} horizontal tokens={{ childrenGap: 8, padding: 1 }}>
      <div className="trivia-wrapper summary-bar-schedule-container">
        <div className={labelClassName}>
          {i18n.getString(_TL_('Scheduling frequency'))}
        </div>
        <span className={`${schedulerTextClassName} scheduler-text`}>{displayFrequency}</span>
        <ScheduleFrequencyIconEditor
          data={schedulerOptions}
          onSchedulerSaveClick={onSchedulerSaveClick}
          calloutProps={{
            target: '.summary-bar-schedule-container',
            gapSpace: 8,
          }}
        />
      </div>
      <div className="trivia-wrapper">
        <div className={labelClassName}>
          {i18n.getString(_TL_('Shared'))}
        </div>
        <span>
          {
            isReportShared ?
              i18n.getString(_TL_('Yes')) :
              i18n.getString(_TL_('No'))
          }
        </span>
      </div>
    </Stack>
  );
}
